module.exports = __webpack_public_path__ + "static/media/Blyant-min.1ef3ffad.PNG";